export default {
  'lv0':[{
    text:'Aa',
    spot:'a',
    path:'/static/voice/know/1/A.mp3',
  },{
    text:'Bb',
    spot:'b',
    path:'/static/voice/know/1/B.mp3',
  },{
    text:'Cc',
    spot:'c',
    path:'/static/voice/know/1/C.mp3',
  },{
    text:'Dd',
    spot:'d',
    path:'/static/voice/know/1/D.mp3',
  },{
    text:'Ee',
    spot:'e',
    path:'/static/voice/know/1/E.mp3',
  },{
    text:'Ff',
    spot:'f',
    path:'/static/voice/know/1/F.mp3',
  },{
    text:'Gg',
    spot:'g',
    path:'/static/voice/know/1/G.mp3',
  },{
    text:'Hh',
    spot:'h',
    path:'/static/voice/know/1/H.mp3',
  },{
    text:'Ii',
    spot:'i',
    path:'/static/voice/know/1/I.mp3',
  },{
    text:'Jj',
    spot:'j',
    path:'/static/voice/know/1/J.mp3',
  },{
    text:'Kk',
    spot:'k',
    path:'/static/voice/know/1/K.mp3',
  },{
    text:'Ll',
    spot:'l',
    path:'/static/voice/know/1/L.mp3',
  },{
    text:'Mm',
    spot:'m',
    path:'/static/voice/know/1/M.mp3',
  },{
    text:'Nn',
    spot:'n',
    path:'/static/voice/know/1/N.mp3',
  },{
    text:'Oo',
    spot:'o',
    path:'/static/voice/know/1/O.mp3',
  },{
    text:'Pp',
    spot:'p',
    path:'/static/voice/know/1/P.mp3',
  },{
    text:'Qq',
    spot:'q',
    path:'/static/voice/know/1/Q.mp3',
  },{
    text:'Rr',
    spot:'r',
    path:'/static/voice/know/1/R.mp3',
  },{
    text:'Ss',
    spot:'s',
    path:'/static/voice/know/1/S.mp3',
  },{
    text:'Tt',
    spot:'t',
    path:'/static/voice/know/1/T.mp3',
  },{
    text:'Uu',
    spot:'u',
    path:'/static/voice/know/1/U.mp3',
  },{
    text:'Vv',
    spot:'v',
    path:'/static/voice/know/1/V.mp3',
  },{
    text:'Ww',
    spot:'w',
    path:'/static/voice/know/1/W.mp3',
  },{
    text:'Xx',
    spot:'x',
    path:'/static/voice/know/1/X.mp3',
  },{
    text:'Yy',
    spot:'y',
    path:'/static/voice/know/1/Y.mp3',
  },{
    text:'Zz',
    spot:'z',
    path:'/static/voice/know/1/Z.mp3',
  },],

  'lv1':[{
    pic:'/static/images/ceshiti/prereading/1.png',
    spot:'pirate',
    answer:'p',
    path:'/static/voice/know/2/pirate.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/2.png',
    spot:'grapes',
    answer:'g',
    path:'/static/voice/know/2/grapes.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/3.png',
    spot:'strawberries',
    answer:'s',
    path:'/static/voice/know/2/Strawberries.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/4.png',
    spot:'hole',
    answer:'h',
    path:'/static/voice/know/2/hole.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/5.png',
    spot:'nest',
    answer:'n',
    path:'/static/voice/know/2/nest.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/6.png',
    spot:'piano',
    answer:'p',
    path:'/static/voice/know/2/Piano.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/7.png',
    spot:'drum',
    answer:'d',
    path:'/static/voice/know/2/drum.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/8.png',
    spot:'bath',
    answer:'b',
    path:'/static/voice/know/2/Bath.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/9.png',
    spot:'socks',
    answer:'s',
    path:'/static/voice/know/2/socks.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/10.png',
    spot:'rooster',
    answer:'r',
    path:'/static/voice/know/2/rooster.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/11.png',
    spot:'pig',
    answer:'p',
    path:'/static/voice/know/2/Pig.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/12.png',
    spot:'pull',
    answer:'p',
    path:'/static/voice/know/2/pullmp3.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/13.png',
    spot:'skip',
    answer:'s',
    path:'/static/voice/know/2/skip.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/14.png',
    spot:'vegetables',
    answer:'v',
    path:'/static/voice/know/2/Vegetables.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/15.png',
    spot:'seeds',
    answer:'s',
    path:'/static/voice/know/2/seeds.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/16.png',
    spot:'flower',
    answer:'f',
    path:'/static/voice/know/2/flower.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/17.png',
    spot:'octopus',
    answer:'o',
    path:'/static/voice/know/2/Octopus.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/18.png',
    spot:'dolphin',
    answer:'d',
    path:'/static/voice/know/2/dolphin.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/19.png',
    spot:'tiger',
    answer:'t',
    path:'/static/voice/know/2/tiger.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/20.png',
    spot:'fish',
    answer:'f',
    path:'/static/voice/know/2/fish.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/21.png',
    spot:'plane',
    answer:'p',
    path:'/static/voice/know/2/plane.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/22.png',
    spot:'train',
    answer:'t',
    path:'/static/voice/know/2/train.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/23.png',
    spot:'bird',
    answer:'b',
    path:'/static/voice/know/2/Bird.mp3',
  },{
    pic:'/static/images/ceshiti/prereading/24.png',
    spot:'kitten',
    answer:'k',
    path:'/static/voice/know/2/Kitten.mp3',
  },]

}



// WEBPACK FOOTER //
// ./src/testdata/know.js